
const UpdateSuccess = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M19.479 10.092c-.212-3.951-3.473-7.092-7.479-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408zm-8.252 6.819c-1.115-1.312-1.859-2.148-3.227-3.417l.685-.632c.8.387 1.308.682 2.207 1.323 1.691-1.919 2.809-2.893 4.885-4.185l.223.513c-1.713 1.494-2.968 3.159-4.773 6.398z" />
  </svg>
);

export default UpdateSuccess;
